<template>
  <div class="rank-option" :data-value="props.option.value" v-if="show">
    <div class="rank-option-content">
      <div class="rank-handle">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path d="M5,10.8c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5s0.1-0.4,0.2-0.5C4.6,9.3,4.8,9.2,5,9.2h14c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5s-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2H5z M5,14.8c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5s0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2h14c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5s-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2H5z"/>
        </svg>
      </div>
      <div class="rank-meta">
        <div class="rank-order"></div>
        <div class="rank-name">
          {{ props.option.name.get() }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import Option from '../../models/Option';
import { getCurrentInstance, ref, watch } from 'vue';

const props = defineProps<{
  option: Option,
  submission: any
}>();

const instance = getCurrentInstance();

const getShow = () => {
  const requiredQuestionId = props.option.requires.requiredQuestion;
  const requiredQuestion = props.submission.root[requiredQuestionId];
  if(!requiredQuestion) {
    return false;
  }
  const values = Object.keys(props.submission.root[requiredQuestionId]).filter(a => props.submission.root[requiredQuestionId][a]);
  const requiredValue = props.option.requires.requiredOption;
  return values.includes(requiredValue.toString());
}

const show = ref(getShow());

watch(props.submission.root, () => {
  const shouldShow = getShow();
  if(show.value == shouldShow) {
    return;
  }
  show.value = shouldShow;
  instance.emit('input');
});
</script>

<style lang="scss" scoped>
@import "../../../../core/typography";
.rank-option {
  --rank-order-size: 24px;
  background: #fff;
  border-radius: 10px;
  border: 1px solid rgba(var(--mc-2022-silver-color-rgb), 0.5);
  box-shadow: 0 5px 10px rgba(var(--mc-2022-silver-color-rgb), 0.25);
  cursor: grab;
  .rank-option-content {
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 64px;
    padding: 20px 30px 20px 10px;
  }
  .rank-handle svg {
    display: block;
    fill: #4c5c67;
    opacity: 0.65;
  }
  .rank-meta {
    display: flex;
    gap: 10px;
  }
  .rank-order {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: var(--rank-order-size);
    height: var(--rank-order-size);
    font-weight: 600;
    font-size: 11px;
    color: var(--mc-2022-link-color);
    border-radius: calc(var(--rank-order-size) / 2);
    border: 2px solid var(--mc-2022-link-color);
  }
  .rank-name {
    display: flex;
    align-items: center;
    min-height: var(--rank-order-size);
    @include font-metrics;
    --font-weight: 500;
    --font-size: 13;
    --line-height: 1.15;
    --color: var(--mc-2022-typography-heading-color);
  }
  &.sortable-ghost {
    background: #edf2f7;
    box-shadow: none;
    .rank-option-content {
      opacity: 0;
    }
  }
}
</style>
